import { useEffect, useRef, useState } from "react";
import { useHistory } from "react-router-dom";
import { queriesPayerEngagements } from "@query";
import { routeHelpersWorkLogsPayeeInProgress } from "../../../modules/WorkLogs/paths";

type Params = {
  payerId: string | null | undefined;
  payerEngagementId: string | null | undefined;
  skip?: boolean;
};

export const useWorkDefinitionRedirect = ({
  payerId,
  payerEngagementId,
  skip
}: Params) => {
  const history = useHistory();
  const [isLoading, setIsLoading] = useState(false);
  const checkedEngagementRef = useRef<string | null>(null);

  useEffect(() => {
    const handleEngagementSelection = async () => {
      if (!payerEngagementId || !payerId) {
        return;
      }

      const engagementKey = `${payerId}/${payerEngagementId}`;
      if (checkedEngagementRef.current === engagementKey) {
        return;
      }
      checkedEngagementRef.current = engagementKey;

      try {
        setIsLoading(true);

        const engagement =
          await queriesPayerEngagements.getPayerEngagement.fetchQueryData({
            payerId,
            payerEngagementId
          });

        if (engagement.workDefinitions?.length) {
          history.push(
            routeHelpersWorkLogsPayeeInProgress.createLocationObject({
              search: { payerId, engagementId: payerEngagementId }
            })
          );
        }
      } catch (error) {
        // An engagement id the API cannot resolve 404s here — the duplicate
        // path seeds exactly those (PLA-3693). Redirecting to work logs is an
        // optimization, so a failed read leaves the user on the form rather
        // than rejecting unhandled.
        console.error("Failed to check the engagement for work logging", error);
      } finally {
        setIsLoading(false);
      }
    };

    if (!!payerId && !!payerEngagementId && !skip) {
      handleEngagementSelection();
    }
  }, [history, payerId, payerEngagementId, skip]);

  return { isLoading };
};
